import React from 'react'
import Page from '../../../../layout/Page'
import { Button, DropdownItemProps } from 'semantic-ui-react'
import Result from '../../../../../common/repository/Result'
import { toast } from '../../../../common/Toast'
import Table from '../../../../app/Table'
import RequirePermission from '../../../../base/RequirePermission'
import permissions from '../../../../../common/permissions'
// import Filters from './Filters'
import FilterPageContext from '../../InvestigatorActivity/FilterPageContext'
import { Link } from 'react-router-dom'
import ReportRepository, { GetAttendentInvestigatorRequestObject } from '../../../../../common/repository/ReportRepository'
import { RouteComponentProps } from "react-router-dom";
import AttendentInvestigator from '../../../../../models/ReportModels/AttendentInvestigator'
import AttendentInvestigatorsColumnRenderer from './AttendentInvestigatorsColumnRenderer'

const statusData = ["Pending", "Accepted", "Rejected"]
const statusDatas = statusData.map((it) => {
    return { text: it, value: it, key: it };
});

interface State {
    loading: boolean
    filter: string
    limit: number
    offset: number
    totalCount: number
    attendentInvest: AttendentInvestigator[]
    loadingEssentialData: boolean
    statusFilter: string
    statusOptions: DropdownItemProps[]
}

interface MatchProps {
    Id: string;
}
interface Props extends RouteComponentProps<MatchProps> { }

class AttendentInvestigators extends React.Component<Props, State> {

    private ReportRepository = new ReportRepository()

    private columnRenderer = new AttendentInvestigatorsColumnRenderer(
        (model: AttendentInvestigator) => {
            let id = model.getId()
            const AttendentId = this.props.match.params;
            return (<>
                <Button
                    style={{ width: 150 }}
                    primary
                    as={Link}
                    to={{
                        pathname: `/master/reports/attendent-investigators/${AttendentId.Id}/attendant-details/${id}`,
                    }}
                >
                    View
                </Button>
            </>)
        },
        (obj: any) => true
    )

    constructor(props: any) {
        super(props)

        this.state = {
            loading: false,
            limit: 10,
            offset: 0,
            filter: '',
            totalCount: 0,
            attendentInvest: [],
            loadingEssentialData: true,
            statusFilter: '',
            statusOptions: statusDatas,
        }

    }

    async componentDidMount() {
        this.loadData()
    }
    private onRowsPerPageChange = (page: number, rowsPerPage: number) => {
        const offset = (page - 1) * rowsPerPage,
            limit = offset + rowsPerPage
        this.setState({ offset, limit }, this.loadData)
    }

    private setFilter = (filter: string) => {
        this.setState({ filter, offset: 0 }, this.loadData)
    }

    private clearAllFilters = async () => {
        await this.setState({
            limit: 0,
            offset: 0,
            statusFilter: '',
        })
        await this.loadData()
    }

    private getAttendentInvestigatorList = async () => {
        const AttendentId = this.props.match.params;
        const ro: GetAttendentInvestigatorRequestObject = {
            limit: this.state.limit,
            offset: this.state.offset,
            search: this.state.filter,
            mobile: AttendentId.Id
        }

        // if (this.state.statusFilter) ro.accepted = this.state.statusFilter

        return await this.ReportRepository.getAttendentInvestigatorList(ro)
    }

    private loadData = async () => {
        if (this.state.statusFilter) {
            await this.setState({ offset: 0 })
        }
        let offset = this.state.offset

        this.setState({ loading: true }, async () => {
            const result = await this.getAttendentInvestigatorList()

            console.log(result, "result")

            if (result instanceof Result.Success) {
                if (offset === 0) {
                    //if offset 0 initialize as new list
                    const attendentInvest = result.data.items
                    const totalCount = result.data.totalItemCount
                    await this.setState({
                        loading: false,
                        // offset: attendentInvest.length,
                        attendentInvest,
                        totalCount: totalCount,
                    })
                } else {
                    //else check for duplicate items in the new data
                    // and then concat with the old
                    const attendentInvest = [...this.state.attendentInvest, ...result.data.items]
                    const offset = attendentInvest.length
                    this.setState({ loading: false, offset, attendentInvest })
                }
            } else {
                const message = result.message || 'Something went wrong'
                await this.setState({ loading: false }, () => toast.error(message))
            }
        })
    }


    private setStatsFilter = (val: string) => this.setState({ statusFilter: val })

    render() {
        return (
           
                <Page title="Attendent Investigator" description="Manage Investigator ">

                    {/* <Segment>
                        <Filters />
                    </Segment> */}

                    <Table
                        renderer={this.columnRenderer}
                        data={this.state.attendentInvest}
                        totalDataCount={this.state.totalCount}
                        loading={this.state.loading}
                        load={this.loadData}
                        onRowsPerPageChange={this.onRowsPerPageChange}
                        onSearch={this.setFilter}
                        onClear={() => this.setFilter('')}
                    />
                </Page>
        )
    }
}

export default (props: any) => {
    return (
        <RequirePermission permission={permissions.Master.CRUD}>
            <AttendentInvestigators {...props} />
        </RequirePermission>
    )
}
